// A largura de cada tela era decidida uma a uma: max-w-6xl aqui, 5xl ali,
// 4xl, 3xl, max-w-full e algumas sem contêiner nenhum. A aplicação mudava de
// largura a cada clique no menu, e as telas de grade desperdiçavam metade do
// monitor.
//
// São duas larguras, e só duas, escolhidas pelo que a tela faz:
//
//   DADOS   — grades, listas, tabelas e quadros. Ocupam o monitor. O teto
//             existe para a linha não virar um trilho em ultrawide, onde o
//             olho perde a ligação entre as pontas da mesma linha.
//   LEITURA — texto corrido e formulários de uma coluna. Continuam estreitos
//             de propósito: linha longa demais cansa e faz perder a linha
//             seguinte na volta.
export const DADOS = "w-full max-w-[1920px] mx-auto px-8 py-8";
export const LEITURA = "w-full max-w-3xl mx-auto px-8 py-8";
